<template>
  <div class="order-detail" v-thematic>
    <select v-model="local_value">
      <option :value="'none'" disabled>
        {{ $t("preorder_details.choose_time") }}
      </option>

      <option :value="null" v-if="allow_asap">
        {{ $t("preorder_time_modal.fast_as_possible") }}
      </option>

      <option v-for="(item, index) in dates" :value="item" :key="index">
        {{ time_only ? '' : formatDay(item) }}
        {{ formatTime(item) }}
      </option>
    </select>
    <img
      :src="currentIcon"
      :class="value == 'none' && valid ? 'disabled' : ''"
    />

    <div class="time-selector-box" v-if="value == 'none'">
      <p
        :class="{
          'color-grey': valid,
          'time-detail': true,
          'detail-red-input': !valid,
        }"
      >
        {{ time_only ? $t("preorder_details.choose_time_only") :  $t("preorder_details.choose_time")}}
      </p>
    </div>

    <div class="time-selector-box" v-else-if="!value">
      <p>
        {{ $t("preorder_time_modal.fast_as_possible") }}
      </p>
    </div>

    <div v-else>
      <p class="time-detail">{{ formatDay(value) }}</p>
      <p class="selective">
        {{ formatTime(value) }}
      </p>
    </div>
    <div class="selective-item">
      <img
        :src="isDarkMode ? '/icons/arrow-black.svg' : '/icons/arrow-white.svg'"
        :class="value == 'none' ? 'arrow disabled' : 'arrow'"
      />
    </div>
  </div>
</template>

<style scoped>
p.selective {
  color: #129b81;
}
</style>

<script>
import moment from "moment";
import ScheduleService from "@/services/schedule";
export default {
  props: {
    value: {
      type: [Date, String],
    },
    dates: {
      type: Array,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    time_only: {
      type: Boolean,
      default: false
    },
    allow_asap: {
      type: Boolean,
      default: false,
    },
    timezone: String
  },
  data() {
    return {
      local_value: 'none'
    };
  },
  watch: {
    local_value() {
      this.$emit('input', this.local_value);
    }
  },
  computed: {
     currentIcon() {
      const themeSuffix = this.isDarkMode ? "-white" : "";
      if (!this.valid && this.value == 'none') return `/icons/details/calendar-red.svg`;
      if (this.value === null) return `/icons/details/calendar${themeSuffix}.svg`;
      return `/icons/details/calendar${themeSuffix}.svg`;
    },
  },
  methods: {
    formatDay(raw) {
      const m = moment(raw).tz(this.timezone);
      const now = moment().tz(this.timezone);

      if (now.isSame(m, "day")) return this.$t("reserve.today");
      if (now.add(1, "day").isSame(m, "day"))
        return this.$t("reserve.tomorrow");

      return m.format("DD.MM.YYYY");
    },
    emitInput(ev) {
      const val = ev.target.value || null;

      console.log(ev);

      this.$emit('input', val);
    },
    formatTime(raw) {
      return moment(raw).tz(this.timezone).format("HH:mm");
    }
  },

  mounted() {
    if (this.dates.length == 1) {
      this.local_value = this.dates[0];
    }
  },  

  filters: {
    formatTime(raw) {
      return moment(raw).format("HH:mm");
    },
    formatDate(raw) {
      return moment(raw).tz(this.timezone).format("DD.MM.YYYY");
    },
  },
};
</script>
